import { render } from "./InvoiceAIPerformance.vue?vue&type=template&id=72bd27d2&scoped=true"
import script from "./InvoiceAIPerformance.vue?vue&type=script&lang=js"
export * from "./InvoiceAIPerformance.vue?vue&type=script&lang=js"

import "./InvoiceAIPerformance.vue?vue&type=style&index=0&id=72bd27d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bd27d2"]])

export default __exports__